import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 010_archive_legacy_invoice_source_tables
//
// Active PINV/DN ownership moved to Accounting in #767. Keep the old
// Purchase-owned physical tables for audit/backfill history, but rename them
// so they cannot be mistaken for live document tables.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "010_archive_legacy_invoice_source_tables",
  version: "1.10.0",
  ignoreErrors: [
    "no such table: purchase_invoices",
    "no such table: purchase_debit_notes",
  ],
  sql: `
ALTER TABLE \`purchase_invoices\` RENAME TO \`purchase_legacy_invoices_archive\`;
ALTER TABLE \`purchase_debit_notes\` RENAME TO \`purchase_legacy_debit_notes_archive\`;
  `.trim(),
};
